import Big from 'big.js'
import {TypeInt} from './../TypeDefinition'

import ProgramCode from './../ProgramCode'

import CodeHelpers from './CodeHelpers.js'
import ParseExpression from './ParseExpression.js'
import ParseSentences from './ParseSentences.js'

function ParseSentenceFor (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.SC = parser.config
    this.hintHelper = parser.hintHelper
}

ParseSentenceFor.prototype = {
    parse () {
        let variable
        let expToken
        let expType
        let forStart
        let doToken
        let branchExitFor
        let stepVarDispl
        let hasStep = false
        let stepToken
        let oldPcode
        let newPcode
        let expectedToken
        let parseExpressionTo
        let codeHelpers = new CodeHelpers(this.parser)
        let parseExpression = new ParseExpression(this.parser)
        let parseSentences = new ParseSentences(this.parser)

        this.parser.expect(this.SC.K_FOR)

        variable = this.parser.expect(this.SC.IDENT)

        if (variable !== false) {
            if (!this.stable.hasStorage(variable.lexema)) {
                this.parser.error(variable, 'Variable ' + variable.lexema + ' no declarada.')
            } else {
                let storage = this.stable.getStorage(variable.lexema)
                if (!storage.getType().isInt()) {
                    this.parser.error(variable, 'La variable debe ser de tipo Entero.')
                } else if (storage.getType().isArray()) {
                    this.parser.error(variable, 'La variable a utilizar no puede ser un arreglo.')
                }
            }
        }

        this.parser.expect(this.SC.ASSIGN)

        expToken = this.scanner.next()

        expType = parseExpression.parse()

        if (!expType.isInt()) {
            this.parser.error(expToken, 'La expresión debe ser de tipo Entero.')
        }

        if (this.parser.compile) {
            codeHelpers.codeStoreVar(variable)
        }

        expectedToken = this.parser.expect(this.SC.K_TO)
        if (this.hintHelper && expectedToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_TO])
        }

        expToken = this.scanner.next()

        if (this.parser.compile) {
            oldPcode = this.pcode
            this.pcode = new ProgramCode()
            this.parser.pcode = this.pcode
            this.pcode.setCurrentContext(oldPcode.getCurrentContext())
        }

        parseExpressionTo = new ParseExpression(this.parser)
        expType = parseExpressionTo.parse()

        if (this.parser.compile) {
            newPcode = this.pcode
            this.pcode = oldPcode
            this.parser.pcode = this.pcode
        }

        if (!expType.isInt()) {
            this.parser.error(expToken, 'La expresión debe ser de tipo Entero.')
        }
        stepToken = this.parser.expect(this.SC.K_STEP)
        hasStep = true
        if (this.parser.compile) {
            this.pcode.push(TypeInt(), 1, stepToken)
            stepVarDispl = this.stable.getCurrentDisplacement()
            this.stable.incrementDisplacement(1)
        }
        let stepType = parseExpression.parse()
        if (!stepType.isInt()) {
            this.parser.error(stepToken, 'La expresión debe ser de tipo Entero.')
        }
        if (this.parser.compile) {
            // stepToken.procName = currentProcName
            this.pcode.store(stepType, stepVarDispl, stepToken)
        }

        doToken = this.parser.expect(this.SC.K_DO)
        if (this.hintHelper && doToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_DO], '\n')
            this.hintHelper.checkTokensForHints([this.SC.K_STEP])
        }

        if (this.parser.compile) {
            forStart = this.pcode.instructionCount() + 1
            this.pcode.copyFrom(newPcode)
            codeHelpers.codeVariableLoad(variable)
            if (hasStep) {
                this.pcode.load(stepType, stepVarDispl, stepToken)
                this.pcode.ccmp(doToken)
            } else {
                this.pcode.gte(doToken)
            }
            branchExitFor = this.pcode.branch(0, doToken)
        }

        parseSentences.parse()

        expectedToken = this.parser.expect(this.SC.K_END_FOR)
        if (this.hintHelper && expectedToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_END_FOR], '\n')
        }

        if (this.parser.compile) {
            // Increment
            codeHelpers.codeVariableLoad(variable.lexema, expectedToken)
            if (hasStep) {
                this.pcode.load(stepType, stepVarDispl, expectedToken)
            } else {
                this.pcode.ldcte(TypeInt(), new Big(1), this.scanner.next())
            }
            this.pcode.sum(expectedToken)
            codeHelpers.codeStoreVar(variable.lexema, expectedToken)

            // Repeat
            this.pcode.jump(forStart, expectedToken)

            this.pcode.pop(stepType, 1, expectedToken)
            this.stable.incrementDisplacement(-1)
            branchExitFor.op1 = this.pcode.instructionCount()
        }
    }
}

export default ParseSentenceFor



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseSentenceFor.js